var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-card-content" } },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("app-select-tier", {
                attrs: { fancy: "", label: "Tier" },
                model: {
                  value: _vm.sub.plan.tier,
                  callback: function ($$v) {
                    _vm.$set(_vm.sub.plan, "tier", $$v)
                  },
                  expression: "sub.plan.tier",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("w-input-number", {
                attrs: { decimals: 2, fancy: "", label: "Prijs" },
                model: {
                  value: _vm.sub.price,
                  callback: function ($$v) {
                    _vm.$set(_vm.sub, "price", $$v)
                  },
                  expression: "sub.price",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { sm: "6", xs: "12" } },
            [
              _c("w-select", {
                attrs: {
                  fancy: "",
                  label: "Betaal frequentie",
                  items: _vm.paymentFrequencyItems,
                },
                model: {
                  value: _vm.sub.plan.paymentFrequency,
                  callback: function ($$v) {
                    _vm.$set(_vm.sub.plan, "paymentFrequency", $$v)
                  },
                  expression: "sub.plan.paymentFrequency",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("w-date-picker", {
                attrs: { fancy: "", label: "Volgende betaaldatum" },
                model: {
                  value: _vm.sub.nextPaymentDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.sub, "nextPaymentDate", $$v)
                  },
                  expression: "sub.nextPaymentDate",
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("w-checkbox", {
                attrs: { fancy: "", label: "Standaard modules NIET toevoegen" },
                model: {
                  value: _vm.sub.plan.dontAddDefaultModules,
                  callback: function ($$v) {
                    _vm.$set(_vm.sub.plan, "dontAddDefaultModules", $$v)
                  },
                  expression: "sub.plan.dontAddDefaultModules",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-list",
        [
          _vm._l(_vm.sub.plan.modules, function (mod, i) {
            return _c(
              "w-list-item",
              { key: mod.ID },
              [
                _c("w-list-item-text", [_vm._v(_vm._s(mod.getModuleName()))]),
                _c(
                  "w-list-item-action",
                  [
                    mod.hasMetaData()
                      ? _c(
                          "w-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.editMetadata(mod)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "pen" } })],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "w-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.removeModule(i)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-list-item",
            {
              on: {
                click: function ($event) {
                  _vm.selectModuleOpen = true
                },
              },
            },
            [
              _c("w-list-item-text", [
                _c(
                  "div",
                  [
                    _c("w-fa", { attrs: { icon: "plus" } }),
                    _vm._v(" Module toevoegen"),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-row",
        [
          _c("w-spacer"),
          _c(
            "w-link",
            {
              on: {
                click: function ($event) {
                  return _vm.onRawClicked()
                },
              },
            },
            [_vm._v("Raw")]
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.selectModuleOpen,
            callback: function ($$v) {
              _vm.selectModuleOpen = $$v
            },
            expression: "selectModuleOpen",
          },
        },
        [
          _c("app-module-select-modal", {
            attrs: {
              multiple: "",
              title: "Modules toevoegen",
              "ignored-modules": _vm.ignoredModules,
            },
            on: {
              close: function ($event) {
                _vm.selectModuleOpen = false
              },
              input: function ($event) {
                return _vm.addModules($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditModuleWithMetaData != null } },
        [
          _vm.toEditModuleWithMetaData
            ? _c("app-company-edit-subscription-module-meta-data", {
                on: {
                  close: function ($event) {
                    _vm.toEditModuleWithMetaData = null
                  },
                },
                model: {
                  value: _vm.toEditModuleWithMetaData,
                  callback: function ($$v) {
                    _vm.toEditModuleWithMetaData = $$v
                  },
                  expression: "toEditModuleWithMetaData",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }